import React, { ReactElement, useState, useEffect } from "react";

import { DefaultPlayer as Video } from "react-html5video";
import "react-html5video/dist/styles.css";

import { storage } from "../../../apis/firebase";
import { ref, getDownloadURL } from "firebase/storage";

const Intro = ({ data, idx }): ReactElement => {
  const [response, setIsResponse] = useState<any>({});
  const [featuredImage, setFeaturedImage] = useState("");
  const [featuredCloudVideo, setFeaturedCloudVideo] = useState(null);

  useEffect(() => {
    setIsResponse(data);
    if (data.featuredPhoto) {
      (async () => {
        setFeaturedImage(await getStorageFileUrl(data.featuredPhoto));
      })();
    } else {
      setFeaturedImage(null);
    }
    if (data.featuredCloudVideo) {
      (async () => {
        setFeaturedCloudVideo(await getStorageFileUrl(data.featuredCloudVideo));
      })();
    } else {
      setFeaturedCloudVideo(null);
    }
  }, [data]);

  const getStorageFileUrl = async (url): any => {
    if (url) {
      return await getDownloadURL(ref(storage, url));
    }
  };

  return (
    <>
      {!!response && (
        <div className="mt-3 mt-lg-5" key={idx}>
          <div className="row">
            <div
              className={`${
                !(
                  !!response.featuredVideo ||
                  !!response.featuredPhoto ||
                  !!response.featuredCloudVideo
                )
                  ? "col-lg-12"
                  : "col-lg-8"
              } d-flex flex-column`}>
              <div className="tm__content">
                <div className="tm__content-head d-flex justify-content-between">
                  <h2 className="fw-bold m-0">{response.title}</h2>
                </div>
                {!!response.description && (
                  <div
                    className="tm__content-body"
                    dangerouslySetInnerHTML={{
                      __html: response.description,
                    }}></div>
                )}
              </div>
            </div>
            {!!response.featuredVideo ? (
              <div className="col-lg-4 d-flex flex-column">
                <div className="tm__card m-0">
                  <div
                    className="w-100 h-100"
                    dangerouslySetInnerHTML={{
                      __html: response.featuredVideo,
                    }}></div>
                </div>
              </div>
            ) : !!featuredCloudVideo ? (
              <div className="col-lg-4 d-flex flex-column">
                <div className="tm__card m-0">
                  <Video
                    controls={[
                      "PlayPause",
                      "Seek",
                      "Time",
                      "Volume",
                      "Fullscreen",
                    ]}
                    onCanPlayThrough={() => {
                      // Do stuff
                    }}>
                    <source src={featuredCloudVideo} type="video/mp4" />
                  </Video>
                </div>
              </div>
            ) : !!response.featuredPhoto ? (
              <div className="col-lg-4 d-flex flex-column">
                <div className="tm__card p-2">
                  <div
                    className="tm__card-head "
                    style={{
                      backgroundImage: `url(${featuredImage})`,
                      backgroundSize: "contain",
                    }}></div>
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Intro;
